import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { Routes, RouterModule } from "@angular/router";

import { IonicModule } from "@ionic/angular";
import { NewsPage } from "./news.page";

import { ComponentModule } from "../../components/component.module";
import { TranslateModule } from "@ngx-translate/core";

const routes: Routes = [
    {
        path: "",
        component: NewsPage
    }
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        RouterModule.forChild(routes),
        ComponentModule,
        TranslateModule
    ],
    declarations: [NewsPage]
})
export class NewsPageModule {}
